<div class="banner" role="alert">
  <aiwyn-icon name="alert-triangle" class="banner-icon" [height]="20" [width]="20"></aiwyn-icon>
  <p class="banner-message">{{ message() }}</p>
  <button
    andButton
    color="negative"
    size="small"
    class="banner-cta"
    [class.banner-cta-active]="filterActive()"
    [dataSelector]="'cxp-crl-action-banner-filter'"
    (click)="filterRequested.emit()"
  >{{ ctaLabel() }}</button>
</div>
